import { NotificationTopic } from "./notificationTopic";

export class UserPreferences {
    id: number;
    sendUnreadedNotificationsByEmail: boolean;
    suscribedTopics: NotificationTopic[];
    constructor(value: Object = {}) {
        Object.assign(this, value);
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/userPreferences.ts